export enum TcddSubSystem {
  MAIN_SYSTEM = 'mainSystem',
  TEXT_SYSTEM = 'textSystem',
  TRACTION_SYSTEM = 'tractionSystem',
  SIGNALIZATION_SYSTEM = 'signalizationSystem',
  COMMUNICATION_SYSTEM = 'communicationSystem',
  BRAKE_SYSTEM = 'brakeSystem',
  POWER_VOLTAGE_SYSTEM = 'powerVoltageSystem',
  AIR_CONDITION_SYSTEM = 'airConditionSystem',
  DOOR_SYSTEM = 'doorSystem',
  OTHER_SYSTEM = 'otherSystem'
}
